// @core/api/endpoints/audittrail/process_data_subject_access_request.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  DataSubjectAccessRequestResponse,
  ProcessDataSubjectAccessRequestRequest,
} from '../../../types/audittrail';

const BASE_PATH = '/audittrail';

/**
 * Process data subject access request
 * Processes a DSAR by completing or rejecting it. Completed requests include a response data URL. Rejected requests require a justification.
 */
export async function ProcessDataSubjectAccessRequest(
  request_id: string,
  data: ProcessDataSubjectAccessRequestRequest,
  options?: RequestOptions
): Promise<DataSubjectAccessRequestResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/audit/dsar/:request_id/process`;
  requestPath = requestPath.replace(':request_id', encodeURIComponent(request_id));
  const requestOptions = options;
  return client.post<DataSubjectAccessRequestResponse>(requestPath, data, requestOptions);
}
